import { graphql, useStaticQuery } from 'gatsby';

export function useInsightsVideo(videoIdArray) {
  const {
    allRndVideo: { nodes: videos },
  } = useStaticQuery(graphql`
    query {
      allRndVideo {
        nodes {
          ...Video
        }
      }
    }
  `);

  if (videoIdArray) {
    return videoIdArray.map(id => videos.find(video => video.itemId === id));
  }

  return videos;
}
